export const playwright_login_card = "login.card";
export const playwright_login_passwordInput = "login.password-input";
export const playwright_login_usernameInput = "login.username-input";
export const playwright_login_loginButton = "login.button";
